var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51563 -4.76837e-07L3.3125 11.3984H1.14844L0.945313 -4.76837e-07H3.51563ZM2.23438 16.1484C1.80208 16.1484 1.43229 15.9974 1.125 15.6953C0.817708 15.388 0.666667 15.0182 0.671875 14.5859C0.666667 14.1589 0.817708 13.7943 1.125 13.4922C1.43229 13.1849 1.80208 13.0312 2.23438 13.0312C2.65625 13.0312 3.02083 13.1849 3.32812 13.4922C3.63542 13.7943 3.79167 14.1589 3.79688 14.5859C3.79167 14.8724 3.71615 15.1354 3.57031 15.375C3.42969 15.6094 3.24219 15.7969 3.00781 15.9375C2.77344 16.0781 2.51563 16.1484 2.23438 16.1484Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon1);
export default __webpack_public_path__ + "static/media/download-icon-1.dc099fc34733a9c6449d013475f286cd.svg";
export { ForwardRef as ReactComponent };